import panel from '@/core/routes/paths/panel'
import authentication from '@/core/routes/paths/authentication'
import errors from '@/core/routes/paths/errors'


export default [
    ...panel,
    ...authentication,
    ...errors
]

